import {IWaiter} from "src/app/core/interfaces/waiter.interface";
import {DomainEvent} from "@platform/event-bus/domain/model/domain-event.model";

export class CurrentWaiterUpdatedEvent implements DomainEvent {
  readonly occurredAt = new Date();

  constructor(readonly waiter?: IWaiter) {
  }
}
